module.exports = __webpack_public_path__ + "img/00030.c848451c.webp";